<!--
 * @Descripttion: 
 * @version: 
 * @Author: A21
 * @Date: 2021-12-21 15:05:30
 * @LastEditors: A21
 * @LastEditTime: 2022-09-16 15:03:05
 * @FilePath: /intell-loan/src/components/Button.vue
-->
<template>
  <div class="button">
    <van-button
      :type="type"
      :plain="plain"
      :disabled="disabled"
      @click="click"
      :loading="loading"
      :loadingText="loadingText"
      >{{ text }}</van-button
    >
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: {
    click: Function,
    text: String,
    type: String,
    plain: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.button {
  padding-right: 15px;

  /* padding-top: 100px; */
  padding-left: 15px;
}
.button >>> .van-button {
  width: 100%;
}
.van-button--disabled {
  color: #fff;
  background-color: #7691a3 !important;
  border: 1px solid #7691a3 !important;
}
.van-button--danger {
  background: #ff6538;
  border-radius: 4px;
  font-size: 17px;
}
.van-button--normal {
  font-size: 17px;
}
</style>
